import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable, catchError, throwError } from "rxjs";
import { clearStorage } from "src/app/common/functions/storage.functions";
import { API } from "src/app/common/models/api.enum";
import { CommonSignalStore } from "src/app/common/signal-stores/common-store/common.store";
import { AlertService } from "src/app/services/alert.service";

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const router = inject(Router);
  const alertService = inject(AlertService);
  const commonStore = inject(CommonSignalStore);
  const modelService = inject(NgbModal);

  return next(req).pipe(
    catchError((errorRes: any) => {
      const is401 = errorRes.status === 401;
      const isOffline = !errorRes.status && !navigator.onLine;
      const endpoint =
        req.url.includes(API.AGENT_KEY) ||
        req.url.includes(API.TWO_FA) ||
        req.url.includes(API.WEBRTC);

      // App appearance (config.json) failures are handled by the app-appearance
      // effect, which falls back to default whitelabeling on 404. Rethrow the
      // original error untouched (so its status is preserved) and skip the
      // generic alert - a missing config.json is an expected, handled case.
      if (req.url.includes("config.json")) {
        return throwError(() => errorRes);
      }

      // === 401 Handling ===
      if (is401 && !endpoint) {
        modelService.dismissAll();
        clearStorage();
        commonStore.reset();
        setTimeout(() => {
          if (!router.url.startsWith("/login")) {
            router.navigate(["/login"]);
          }
        }, 50);
      }

      // === Alert Handling ===
      const title = isOffline
        ? "Network Error"
        : is401
          ? ""
          : `${errorRes.statusText}`;

      const message = isOffline
        ? "Please connect to the internet"
        : errorRes?.error?.desc || errorRes?.error?.message || "";

      const list = [
        {
          url: API.CONVERSATIONS_HISTORY,
          message: "Please provide Valid Key",
          display: true,
        },
      ];
      const item = list.find((i) => req.url.includes(i.url));
      if (item) {
        if (item.display) {
          alertService.alertDanger("Error", item.message);
        }
        return throwError(() => errorRes.error);
      } else {
        alertService.alertDanger(message ? "" : title, message);
      }

      // === Return Error ===
      if (req.url.includes(API.SSO_LOGIN)) {
        return throwError(() => errorRes.error);
      }

      return throwError(
        () =>
          new Error(
            message || "A network error occurred. Please try again later.",
          ),
      );
    }),
  );
};
